// AD-2776 (Maria, 24 October 2026), the same rule as the server (FormAccessRule): the creator of a form always has Edit
// access. A member of staff named on the form has the access set for them by name, whatever their roles have. Anyone
// else has Edit access when one of their roles on the form has Edit access, and View access when their roles are only
// on it with View. A School Admin has the access the school sets for them, like anyone else.
export const isViewOnlyFor = (formAccess, user) => {
    if (!formAccess || !user?.id) return false;
    if (formAccess.creatorUserId && formAccess.creatorUserId === user.id) return false;
    if ((formAccess.userIds ?? []).includes(user.id)) {
        return (formAccess.viewOnlyUserIds ?? []).includes(user.id);
    }
    const myRoles = user.roles ?? [];
    const byRole = (formAccess.roles ?? []).filter(role => myRoles.includes(role));
    if (byRole.length === 0) return false;
    return byRole.every(role => (formAccess.viewOnlyRoles ?? []).includes(role));
};
